import * as request from '@/utils/request'
const BASE_URL = 'api'
export default {
  /**
   * @description 权限管理 新增
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  createPermissions(data) {
    return request.post(`${BASE_URL}/permissions/store`, data)
  },

  /**
   * @description 权限管理 编辑
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  updatePermissions(id, data) {
    return request.put(`${BASE_URL}/permissions/update/${id}`, data)
  },

  /**
   * @description 权限管理 列表
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  getPermissionsList() {
    return request.get(`${BASE_URL}/permissions/list`)
  },

  /**
   * @description 权限管理 详情
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  viewPermissions(data){
    return request.get(`${BASE_URL}/permissions/view/${data}`)
  },

   /**
   * @description 权限管理 权限的拖拽排序
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  orderPermissions(data){
    return request.post(`${BASE_URL}/permissions/order`, data)
  },

  /**
   * @description 权限管理 删除
   * @author YM
   * @date 2019-01-10
   * @returns promise
   */
  deletePermissions(data){
    return request.Delete(`${BASE_URL}/permissions/delete/${data}`)
  }


  
  // /**
  //  * @description 权限管理 新增
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // createMeun(data) {
  //   return request.post('/menu/store', data)
  // },
  // /**
  //  * @description 权限管理 编辑
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // updateMenu(id, data) {
  //   return request.put(`/menu/update/${id}`, data)
  // },

  // /**
  //  * @description 权限管理 列表
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // getMenuList() {
  //   return request.get(`/menu/list`)
  // },

  //  /**
  //  * @description 权限管理 详情
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // viewMenu(data) {
  //   return request.get(`/menu/view/${data}`)
  // },

  //  /**
  //  * @description 权限管理 菜单的拖拽排序
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // orderMenu(data) {
  //   return request.get(`/menu/order`, data)
  // },

  // /**
  //  * @description 权限管理 删除菜单
  //  * @author YM
  //  * @date 2019-01-10
  //  * @returns promise
  //  */
  // deleteMenu(data) {
  //   return request.Delete(`/menu/delete/${data}`)
  // },





  // /**
  //  * @description 获取权限列表
  //  * @author YM
  //  * @date 2019-01-17
  //  * @returns promise
  //  */
  // getPermissionsList() {
  //   return request.post('/permissions/list')
  // },
  // /**
  //  * @description 保存权限，新建、编辑的保存都走此方法，却别是有没有主键id
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // savePermissions(data) {
  //   return request.post('/permissions/store',data)
  // },
  // /**
  //  * @description 根据id获取单条信息，编辑使用
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // getPermissionsInfo(id) {
  //   let data = {id:id}
  //   return request.post('/permissions/get_info',data)
  // },
  // /**
  //  * @description 根据id删除单条信息
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // deletePermissions(id) {
  //   let data = {id:id}
  //   return request.post('/permissions/delete',data)
  // },
  // /**
  //  * @description 相同层级权限排序
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // orderPermissions(ids) {
  //   let data = {ids:ids}
  //   return request.post('/permissions/order',data)
  // }
}